<template>
  <div class="box">
    <nav class="level is-mobile">
      <div class="level-item has-text-centered">
        <div>
          <p
            class="heading"
            @click="
              $emit('edit-vending', {
                vending,
                form: 'general-info'
              })
            "
          >
            <a>{{ vending.vendingInfo.name }}</a>
          </p>

          <p
            class="has-cursor-pointer"
            @click="
              $emit('edit-vending', {
                vending,
                form: 'general-info'
              })
            "
          >
            {{
              `${getManufacturerName(vending.vendingInfo.manufacturer)} - ${
                vending.vendingInfo.model
              }`
            }}
          </p>
        </div>
      </div>

      <div class="level-item has-text-centered">
        <div>
          <p
            class="heading"
            @click="
              $emit('edit-vending', {
                vending,
                form: 'catalog'
              })
            "
          >
            <a>{{ $tc("vending.category", 2) }}</a>
          </p>

          <p
            class="has-cursor-pointer"
            @click="
              $emit('edit-vending', {
                vending,
                form: 'catalog'
              })
            "
          >
            {{ vending.catalog.length }}
          </p>
        </div>
      </div>

      <div class="level-item has-text-centered">
        <div>
          <p
            class="heading"
            @click="
              $emit('edit-vending', {
                vending,
                form: 'products'
              })
            "
          >
            <a>{{ $t("vending.products") }}</a>
          </p>

          <p
            class="has-cursor-pointer"
            @click="
              $emit('edit-vending', {
                vending,
                form: 'products'
              })
            "
          >
            {{ vending.products.length }}
          </p>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import { vending } from "../../mixins/vending";

export default {
  props: ["vending"],

  mixins: [vending]
};
</script>

<style scoped>
.has-cursor-pointer {
  cursor: pointer;
}
</style>
